module.exports = __webpack_public_path__ + "static/richard-015a15d54494c50c8bfd3b72c0f0e29a.svg";